import { render, staticRenderFns } from "./leaseMagtIndex.vue?vue&type=template&id=2d7203d6&scoped=true"
import script from "./leaseMagtIndex.vue?vue&type=script&lang=js"
export * from "./leaseMagtIndex.vue?vue&type=script&lang=js"
import style0 from "./leaseMagtIndex.vue?vue&type=style&index=0&id=2d7203d6&prod&lang=scss&scoped=true"
import style1 from "./leaseMagtIndex.vue?vue&type=style&index=1&id=2d7203d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7203d6",
  null
  
)

export default component.exports